var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DecimalPipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { ObservableMedia } from '@angular/flex-layout';
import { first } from 'rxjs/operators/first';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { ApplicationService, AdoptionRequestInfo, } from '../../services/application/application.service';
import { AuthService } from '../../services/authentication/auth.service';
import { DialogService } from '../../services/dialogs/dialogs.service';
import { DownloadService } from '../../services/download/download.service';
import { ErrorService } from '../../services/error/error.service';
import { SplashService } from '../../services/splash/splash.service';
import { UserService } from '../../services/user/user.service';
import { SchoolYearPipe } from '../../pipes/schoolyear.pipe';
import { TitleCasePipe } from '../../pipes/titlecase.pipe';
import { Tag, TagTypes } from '../ui/tags/tags.component';
var AdoptionRequestComponent = /** @class */ (function () {
    function AdoptionRequestComponent(appService, authService, decimalPipe, dialogService, downloadService, errorService, fb, mediaChange, route, router, schoolYearPipe, splashService, titleCasePipe, userService) {
        this.appService = appService;
        this.authService = authService;
        this.decimalPipe = decimalPipe;
        this.dialogService = dialogService;
        this.downloadService = downloadService;
        this.errorService = errorService;
        this.fb = fb;
        this.mediaChange = mediaChange;
        this.route = route;
        this.router = router;
        this.schoolYearPipe = schoolYearPipe;
        this.splashService = splashService;
        this.titleCasePipe = titleCasePipe;
        this.userService = userService;
        this._subrelease = new Subject();
        this.AllHeaders = ['LastName', 'FirstName', 'SchoolName', 'RoleName', 'CanBypassAdmin', 'DesigneeActions'];
        this.TagTypes = TagTypes;
    }
    Object.defineProperty(AdoptionRequestComponent.prototype, "ProposedUseID", {
        get: function () {
            return this.NewCourseForm && this.NewCourseForm.controls['ProposedUseID'];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdoptionRequestComponent.prototype, "ProposedUseDescription", {
        get: function () {
            return this.NewCourseForm && this.NewCourseForm.controls['ProposedUseDescription'];
        },
        enumerable: true,
        configurable: true
    });
    AdoptionRequestComponent.prototype.ngOnInit = function () {
        var self = this;
        self.AvailableColleges = null;
        self.AvailableSchools = null;
        self.AvailableSchoolYears = null;
        self.CollegeCourseID = null;
        self.CurrentSchoolYear = null;
        self.FromSearch = false;
        self.GradRequirements = null;
        self.NewCourseForm = null;
        self.PartialViewReady = false;
        self.SelectedCollege = null;
        self.SmallDisplay = false;
        self.User = null;
        self.SmallDisplay = self.mediaChange.isActive('xs') || self.mediaChange.isActive('sm');
        self.mediaChange
            .asObservable()
            .pipe(takeUntil(self._subrelease))
            .subscribe(function (media) {
            self.SmallDisplay = media.mqAlias === 'xs' || media.mqAlias === 'sm';
        });
        // Make an empty new user form
        self.NewCourseForm = self.fb.group({
            Code: [null, [Validators.required, Validators.minLength(8), Validators.maxLength(8)]],
            Name: [null, Validators.required],
            GradRequirement: [null, Validators.required],
            ProposedUseID: [null, Validators.required],
            ProposedUseDescription: [null],
            HSCredit: [null, Validators.required],
            ModificationsNeeded: [null, Validators.maxLength(1000)],
            CompanionFieldsNeeded: [null, Validators.maxLength(1000)],
            CompanionFieldsReason: [null, Validators.maxLength(2000)],
            SchoolYear: [null, Validators.required],
            School: [null, Validators.required],
            CollegeIDs: [[], [Validators.min(1)]],
        });
        // Initially disable this control.
        self.NewCourseForm.controls['ProposedUseDescription'].disable();
        // Get the first non-null UserInfo object so we can begin setting up the component
        self.userService.UserSubject.pipe(takeUntil(self._subrelease), first(function (user) { return user && !!user.AuthToken; })).subscribe(function (user) {
            self.User = user;
            // Set up constant monitoring of the user object, to catch AuthToken updates.
            self.userService.UserSubject.pipe(takeUntil(self._subrelease)).subscribe(function (_user) {
                self.User = _user;
            });
            // Load static data for use in the compoment.
            var collegeObs = self.appService.GetAllColleges(self.User.AuthToken);
            var curYearObs = self.appService.GetCurrentSchoolYear();
            var gradReqObs = self.appService.GetAllGradRequirements();
            var schoolsObs = self.appService.GetAllSchools(self.User.AuthToken);
            var schoolYearsObs = self.appService.GetAllSchoolYearsForAdoptions();
            combineLatest(collegeObs, curYearObs, gradReqObs, schoolsObs, schoolYearsObs, self.route.params, function (colleges, curyear, gradreqs, schools, years, params) {
                return {
                    Colleges: colleges,
                    CurrentYear: curyear,
                    GradReqs: gradreqs,
                    Schools: schools,
                    Years: years,
                    Params: params,
                };
            })
                .pipe(takeUntil(self._subrelease))
                .subscribe(function (packet) {
                self.AvailableColleges = packet.Colleges;
                self.AvailableSchools = packet.Schools;
                self.AvailableSchoolYears = packet.Years;
                self.CurrentSchoolYear = packet.CurrentYear;
                self.GradRequirements = packet.GradReqs;
                self.CollegeCourseID =
                    packet.Params && packet.Params['CollegeCourseID'] != null ? +packet.Params['CollegeCourseID'] : null;
                // If the current user has an identified school (not 0000/9000), set that as the current school in the form.
                if (self.User.SchoolNumber && self.User.SchoolNumber !== '0000' && self.User.SchoolNumber !== '9000') {
                    var sch = self.AvailableSchools.find(function (item) { return item.SchoolNumber === self.User.SchoolNumber; });
                    if (sch) {
                        self.NewCourseForm.controls['School'].setValue(sch, { emitEvent: false });
                    }
                }
                // Subscribe to changes in the "ProposedUseID" form value; when it goes to 1, we need to enable the
                // "Other" field and make it required.
                self.ProposedUseID.valueChanges.pipe(takeUntil(self._subrelease)).subscribe(function (val) {
                    if (val === 0) {
                        self.ProposedUseDescription.clearValidators();
                        self.ProposedUseDescription.disable();
                    }
                    else {
                        self.ProposedUseDescription.setValidators(Validators.required);
                        self.ProposedUseDescription.enable();
                    }
                    self.ProposedUseDescription.updateValueAndValidity({ emitEvent: false });
                });
                // Pre-select Polk State for now.
                if (self.AvailableColleges && self.AvailableColleges.length) {
                    self.SelectedCollege = self.AvailableColleges.find(function (item) { return item.CollegeAbbreviation === 'Polk State'; });
                    self.TagOptions = self.AvailableColleges.map(function (c) { return new Tag(c.CollegeName, c.CollegeID, c.Active); });
                }
                // Do we have a params value? If so, we're coming here from a redirect, and try to load the course\
                // info for the course ID given so we can fill in the basic fields.
                if (self.CollegeCourseID != null) {
                    // Get the course info
                    self.appService.GetCollegeCourseInfoByID(self.User.AuthToken, self.CollegeCourseID).subscribe(function (cinfo) {
                        var patch = {
                            // Prefix : cinfo.Prefix,
                            // Code : cinfo.Code,
                            Name: cinfo.Name,
                        };
                        self.NewCourseForm.patchValue(patch);
                        var input = document.querySelector('.codeinput');
                        input.focus();
                        self.PartialViewReady = true;
                    }, function (error) {
                        self.errorService.HandleServiceError(error);
                    });
                }
                else {
                    var input = document.querySelector('.codeinput');
                    input.focus();
                    // Ready for component use.
                    self.PartialViewReady = true;
                }
            }, function (error) {
                self.errorService.HandleServiceError(error);
            });
        });
    };
    AdoptionRequestComponent.prototype.ngOnDestroy = function () {
        this._subrelease.next();
        this._subrelease.complete();
    };
    // #region Add New Request Method
    AdoptionRequestComponent.prototype.AddNewRequest = function (chipCtrl) {
        var self = this;
        var colleges = chipCtrl.value;
        // Patch value from child component before continueing
        if (self.NewCourseForm.get('CollegeIDs')) {
            self.NewCourseForm.get('CollegeIDs').patchValue(colleges.map(function (x) { return x.id; }));
        }
        var form = self.NewCourseForm.getRawValue();
        var nColleges = form.CollegeIDs;
        var collegeNames = self.AvailableColleges.filter(function (x) { return nColleges.includes(x.CollegeID); }).map(function (x) { return x.CollegeName; }).join(', ');
        // Get the user confirmation before proceeding.
        var message = "You are about to submit the following new <strong><em>Dual Enrollment</em></strong> " +
            ("course adoption request:<br /><br /><strong>Course Name/Title: </strong>" + form.Name + "<br />") +
            ("<strong>Course Code: </strong>" + form.Code + "<br /><strong>Program: </strong>" + form.GradRequirement.Name + "<br />") +
            ("<strong>High School Credits: </strong>" + self.decimalPipe.transform(form.HSCredit, '1.1-1') + "<br />") +
            ("<strong>School Year: </strong>" + self.schoolYearPipe.transform(form.SchoolYear) + "<br />") +
            ("<strong>School: </strong>" + form.School.SchoolName + "<br />") +
            ("<strong>College(s): </strong>" + collegeNames + "<br /><br />") +
            "Are you sure you wish to submit the course adoption request as summarized above?";
        self.dialogService
            .OpenConfirmationDialog({
            TitleText: 'Confirmation Requested',
            MessageText: message,
            OKText: "Yes - Submit DE Request",
            CancelText: 'No - CANCEL',
        })
            .subscribe(function (success) {
            if (success === true) {
                // Submit adoption request
                form.SchoolNumber = form.School.SchoolNumber;
                form.GradRequirementID = form.GradRequirement.GradRequirementID;
                self.splashService
                    .DisplaySplash({ TitleText: 'Please Wait', MessageText: 'Submitting request...' })
                    .subscribe(function () {
                    self.appService.AddAdoptionRequest(self.User.AuthToken, self.User.CurrentRole, form, form.CollegeIDs).subscribe(function (adoptID) {
                        self.splashService.CloseSplash();
                        self.splashService.SnackbarSuccess('Course Adoption Request Submitted Successfully.');
                        // Clear the form.
                        self.ResetNewCourseForm(chipCtrl);
                    }, function (error) {
                        self.errorService.HandleServiceError(error);
                    });
                });
            }
        });
    };
    // #endregion
    // #region Reset New Course Form Method
    AdoptionRequestComponent.prototype.ResetNewCourseForm = function (chipCtrl) {
        // Need to pass in control value from child component to manually reset it to remove the chip list when resetting the form.
        if (chipCtrl) {
            chipCtrl.reset();
        }
        this.NewCourseForm.reset();
        var input = document.querySelector('.codeinput');
        input.focus();
        if (this.CollegeCourseID != null) {
            this.router.navigate(['/adoptionrequest']);
        }
    };
    // #endregion
    // #region Show Course Search Method
    AdoptionRequestComponent.prototype.ShowCourseSearch = function () {
        var self = this;
        // Pop up a course search dialog.
        self.dialogService
            .OpenAdoptionCourseSearchDialog({
            TitleText: 'Select course...',
            MessageText: "Use the selection boxes below to choose a course department and specific course to request. " +
                "You may also do a free-text search by using the provided space below, which will look for any courses " +
                "which have the provided text within their course name or course description. Once a course is selected, " +
                "the information for the course will be displayed for your review. To select the course for the adoption " +
                "request form, click the \"Select Course\" button. If you wish to exit without selecting a course, click " +
                "the \"Cancel\" button.",
            Colleges: self.AvailableColleges,
            CurrentSchoolYear: self.CurrentSchoolYear,
            SelectedCollege: self.SelectedCollege,
            OKText: 'Select Course',
            CancelText: 'Cancel',
        })
            .subscribe(function (coursechosen) {
            if (!coursechosen) {
                return;
            }
            // Copy over the details as needed into the new course form.
            var patch = {
                // Prefix : coursechosen.Prefix,
                // Code : coursechosen.Code,
                Name: coursechosen.Name,
            };
            self.NewCourseForm.patchValue(patch);
        });
    };
    return AdoptionRequestComponent;
}());
export { AdoptionRequestComponent };
// #region Custom Classes
// #region New Course Info Class
var NewCourseInfo = /** @class */ (function (_super) {
    __extends(NewCourseInfo, _super);
    function NewCourseInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NewCourseInfo;
}(AdoptionRequestInfo));
export { NewCourseInfo };
// #endregion
// #endregion



// WEBPACK FOOTER //
// ./src/app/adoptionrequest/adoptionrequest.component.ts.pre-build-optimizer.js